/** KAN-851: кнопка "Назад" экранов приложения менеджера (карточки клиента и организации). */
import { ChevronLeft } from 'lucide-react';
import { useMobileBack } from '@/hooks/useMobileBack';

export function MobileBackButton(): JSX.Element {
  const back = useMobileBack();
  return (
    <button
      type="button"
      onClick={back}
      className="-ml-2 inline-flex min-h-[44px] items-center gap-1 px-2 text-base text-blue-600"
    >
      <ChevronLeft className="h-5 w-5" aria-hidden="true" />
      Назад
    </button>
  );
}
